import { useCallback, useEffect, useMemo, useState } from 'react'

import * as R from 'ramda'

import { CustomerAPI } from 'api'

export const FEATURE_ACCESS_LEVELS = Object.freeze({
  READ: 0,
  WRITE: 1,
})

/**
 * Hook to fetch user and check their features
 *
 * @returns { object }
 */
const useFeatureCheck = () => {
  const [features, setFeatures] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchFeatures = useCallback(
    () =>
      setLoading(
        () => true,
        CustomerAPI.get('/users/me')
          .then((res) =>
            setLoading(
              () => false,
              setFeatures(R.pathOr([], ['data', 'features'], res))
            )
          )
          .catch((err) => setLoading(() => false, console.error(err)))
      ),
    []
  )

  const hasFeature = useCallback(
    ({ featureName, accessLevel }) => {
      const featureLevelMap = features[featureName]
      if (!featureLevelMap) {
        return false
      }

      const levelsForFeature = Object.keys(featureLevelMap)
      return levelsForFeature.some(
        (level) =>
          FEATURE_ACCESS_LEVELS[level] >= FEATURE_ACCESS_LEVELS[accessLevel]
      )
    },
    [features]
  )

  useEffect(() => {
    fetchFeatures()
  }, [fetchFeatures])

  return useMemo(
    () => ({ features, hasFeature, loading }),
    [features, hasFeature, loading]
  )
}

export default useFeatureCheck
